"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeAdapterFactory = void 0;
const FakeAuthAdapter_1 = require("./FakeAuthAdapter");
const FakeHttpAdapter_1 = require("./FakeHttpAdapter");
const FakeSocketAdapter_1 = require("./FakeSocketAdapter");
const FakeStorageAdapter_1 = require("./FakeStorageAdapter");
class FakeAdapterFactory {
    constructor(authAdapter, httpAdapter, socketAdapter, storageAdapter) {
        this.authAdapter = authAdapter || new FakeAuthAdapter_1.FakeAuthAdapter();
        this.httpAdapter = httpAdapter || new FakeHttpAdapter_1.FakeHttpAdapter();
        this.socketAdapter = socketAdapter || new FakeSocketAdapter_1.FakeSocketAdapter();
        this.storageAdapter = storageAdapter || new FakeStorageAdapter_1.FakeStorageAdapter();
    }
    withAuthStatusManager(authStatusManager) {
        this.authStatusManager = authStatusManager;
        return this;
    }
    createAuthAdapter() {
        return this.authAdapter;
    }
    createHttpAdapter() {
        return this.httpAdapter;
    }
    createOrgHttpAdapter() {
        return this.httpAdapter;
    }
    createSocketAdapter() {
        return this.socketAdapter;
    }
    createStorageAdapter() {
        return this.storageAdapter;
    }
    withAuthAdapter(authAdapter) {
        this.authAdapter = authAdapter;
        return this;
    }
    withHttpAdapter(httpAdapter) {
        this.httpAdapter = httpAdapter;
        return this;
    }
    withSocketAdapter(socketAdapter) {
        this.socketAdapter = socketAdapter;
        return this;
    }
    withStorageAdapter(storageAdapter) {
        this.storageAdapter = storageAdapter;
        return this;
    }
    withInternetStatusManager(internetStatusManager) {
        this.internetStatusManager = internetStatusManager;
        return this;
    }
}
exports.FakeAdapterFactory = FakeAdapterFactory;
